module.exports = __webpack_public_path__ + "static/media/help.d50497f1.svg";